import React from "react";
import { CheckIcon } from "../membershipGuideIcons";
import {
  PLANS,
  PLAN_HIGHLIGHTS,
  PLAN_ROWS,
  REGION_GRADES,
  PRICE_MATRIX,
} from "../membershipGuideConst";

const Yes = () => <span className="yes">✓</span>;
const No = () => <span className="no">–</span>;
const Rank = ({ n }) => <span className={`rank-${n}`}>{n}순위</span>;

const renderCell = (v) => {
  if (v === true) return <Yes />;
  if (v === false) return <No />;
  if (typeof v === "number") return <Rank n={v} />;
  return v;
};

const PlanHeader = ({ plan }) => (
  <div className={`plan-head${plan.featured ? " featured" : ""}`}>
    <div className="plan-name">
      {plan.name}
      {plan.limited && <span className="plan-chip">정원제</span>}
    </div>
    <div className="plan-desc">{plan.desc}</div>
    <div className="plan-price">
      <strong>{plan.priceLabel}</strong>
      {plan.priceSub}
    </div>
  </div>
);

const PlanRow = ({ row, plans }) => {
  if (row.section) {
    return <div className="plan-section-label">{row.section}</div>;
  }
  return (
    <>
      <div className="plan-cell row-label">{row.label}</div>
      {row.vals.map((v, j) => (
        <div key={j} className={`plan-cell${plans[j].featured ? " featured-col" : ""}`}>
          {renderCell(v)}
        </div>
      ))}
    </>
  );
};

const PlanMobileCard = ({ plan, onOpenConsult }) => (
  <div className={`plan-card${plan.featured ? " featured" : ""}`}>
    <div className="plan-name">
      {plan.name}
      {plan.limited && <span className="plan-chip">정원제</span>}
    </div>
    <div className="plan-desc">{plan.desc}</div>
    <div className="plan-price">
      {plan.priceLabel} <em>{plan.priceSub}</em>
    </div>
    <ul>
      {(PLAN_HIGHLIGHTS[plan.name] || []).map((h, i) => (
        <li key={i}>
          <CheckIcon />
          {h}
        </li>
      ))}
    </ul>
    {plan.name !== "무료" && (
      <button
        type="button"
        className={`btn ${plan.featured ? "btn-primary" : "btn-secondary"} btn-lg`}
        onClick={onOpenConsult}
        style={{ width: "100%" }}
      >
        상담 예약
      </button>
    )}
  </div>
);

const RegionPricing = () => (
  <div className="region-pricing">
    <div className="region-pricing-head">
      <h3>지역 등급별 월 구독료</h3>
      <p>활동 지역 (중개사무소 등록지 기준) 등급(A / B / C)에 따라 월 구독료가 달라집니다.</p>
    </div>

    <div className="region-grades">
      {REGION_GRADES.map((g) => (
        <div key={g.code} className="region-grade">
          <div className="region-grade-code">{g.code}</div>
          <div>
            <div className="region-grade-title">{g.title}</div>
            <div className="region-grade-desc">{g.desc}</div>
          </div>
        </div>
      ))}
    </div>

    <div className="price-matrix">
      <div className="pm-head pm-plan">멤버십</div>
      <div className="pm-head">A 등급</div>
      <div className="pm-head">B 등급</div>
      <div className="pm-head">C 등급</div>
      {PRICE_MATRIX.map((r) => (
        <React.Fragment key={r.plan}>
          <div className="pm-cell pm-plan">
            <strong>{r.plan}</strong>
            {!r.unlimited && <span className="plan-chip">정원제</span>}
          </div>
          {["a", "b", "c"].map((k) => (
            <div key={k} className="pm-cell">
              <strong>{r[k]}</strong>
              <span>/월</span>
            </div>
          ))}
        </React.Fragment>
      ))}
    </div>

    <div className="plan-notes">
      <div className="plan-note">
        비즈니스·프로 멤버십은 <strong>지역별 제한된 수의 가입자만 선착순</strong>으로 받고 있습니다. 조기
        마감 시 대기 리스트로 안내됩니다.
      </div>
      <div className="plan-note">
        명함이 노출되지 않는 <strong>베이직 멤버십은 지역별 가입자 수 제한이 없습니다.</strong>
      </div>
      <div className="plan-note">
        멤버십 요금은 <strong>지역에 따라 상이</strong>하므로 상담 신청하시면 자세히 안내드립니다.
      </div>
    </div>
  </div>
);

const PlanTable = ({ onOpenConsult }) => (
  <section className="section section-gray" id="plans">
    <div className="container">
      <div className="section-title-row">
        <h2>
          <span className="num">02</span> 멤버십 요금
        </h2>
      </div>

      <div className="plans">
        <div className="plan-head label">등급별 혜택 비교</div>
        {PLANS.map((plan) => (
          <PlanHeader key={plan.name} plan={plan} />
        ))}

        {PLAN_ROWS.map((row, i) => (
          <PlanRow key={row.label || `s${i}`} row={row} plans={PLANS} />
        ))}

        <div className="plan-foot" />
        {PLANS.map((plan) => (
          <div key={plan.name} className={`plan-foot${plan.featured ? " featured-col" : ""}`}>
            {plan.name !== "무료" && (
              <button
                type="button"
                className={`btn ${plan.featured ? "btn-primary" : "btn-secondary"}`}
                onClick={onOpenConsult}
              >
                상담 예약
              </button>
            )}
          </div>
        ))}
      </div>

      <div className="plans-mobile">
        {PLANS.map((plan) => (
          <PlanMobileCard key={plan.name} plan={plan} onOpenConsult={onOpenConsult} />
        ))}
      </div>

      <RegionPricing />
    </div>
  </section>
);

export default PlanTable;
